import type { ContactTranslations } from '../../types';

export const frContact: ContactTranslations = {
  title: 'Contactez-nous',
  subtitle: 'Nous serions ravis de vous entendre.',
  header: {
    title: 'Contactez-nous',
    subtitle: 'Nous serions ravis de vous entendre.',
  },
  form: {
    firstName: 'Pr\u00E9nom',
    lastName: 'Nom',
    email: 'E-mail',
    interested: 'Produit int\u00E9ress\u00E9',
    selectProduct: 'Veuillez s\u00E9lectionner',
    message: 'Message',
    send: 'Envoyer le message',
    sending: 'Envoi en cours...',
  },
  info: {
    headquarters: 'Si\u00E8ge social',
    address: 'B\u00E2timent 25, Parc scientifique et technologique Wanyang, 26 Tingwang Road, Tingjiang Town, District de Mawei, Fuzhou, Fujian, Chine',
    phoneSupport: 'Support t\u00E9l\u00E9phonique',
    phone: '+86-15080458735',
    phoneHours: 'Lun-Ven 9h - 18h (GMT+8)',
    emailUs: '\u00C9crivez-nous',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: 'R\u00E9seau de distributeurs',
    distributorDesc: 'Nous recherchons des distributeurs dans le monde entier. Rejoignez-nous pour apporter le chauffage \u00E9cologique dans votre pays.',
  },
  success: {
    title: 'Message envoy\u00E9 !',
    desc: 'Merci de nous avoir contact\u00E9s. Notre \u00E9quipe commerciale vous r\u00E9pondra dans les 24 heures.',
    sendAnother: 'Envoyer un autre message',
  },
};
